import { Box, styled } from "@mui/material";
import { useRouter } from "next/router";
import React, { useRef, useState } from "react";

import {
  BangaloreFAQ,
  ChennaiFAQ,
  DelhiAndNCRFAQ,
  HyderabadFAQ,
  MumbaiFAQ,
  PuneFAQ,
  vehiclePagefaq,
} from "../../../constants/faq";
import { primary } from "../../../constants/theme";
import FAQSDK from "../../../SDK/FAQ/faq";

const CustomFaq = styled(Box)(({ theme }) => ({
  ".faq-main": {
    background: "rgba(238, 241, 247, 0.4)",
    padding: "12px 10%",
    marginTop: "48px",
    ".heading": {
      textAlign: "center",
      fontStyle: "normal",
      fontWeight: "700",
      fontSize: "44px",
      lineHeight: "78px",
      color: primary.dark,
      marginBottom: "16px",
    },
  },
  ".select-faq": {
    width: "100px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  ".select-language": {
    fontSize: "24px",
    marginRight: "10px",
    marginTop: "10px",
  },

  [theme.breakpoints.down("md")]: {
    ".faq-main": {
      marginTop: "0px",
      padding: "20px 16px",
      ".heading": {
        fontSize: "24px",
        lineHeight: "30px",
        marginBottom: "24px",
      },
    },
    ".select-language": {
      fontSize: "16px",
      marginRight: "10px",
      marginTop: "15px",
    },
  },
}));

const FAQ = ({ faqList = [], headText = "Frequently Asked Questions on Electric Gadi"}) => {
  const [showCount, setShowCount] = useState(1);
  const faqRef = useRef(null);
  const location = useRouter();
  const selectedCityName = location.query.city;
  let faqArray = [];
  if (faqList.length > 0) {
    faqArray = faqList;
  } else {
    faqArray = [...vehiclePagefaq];
  }

  switch (selectedCityName) {
    case "bangalore":
      faqArray = [...BangaloreFAQ, ...vehiclePagefaq];
      break;
    case "hyderabad":
      faqArray = [...HyderabadFAQ, ...vehiclePagefaq];
      break;
    case "mumbai":
      faqArray = [...MumbaiFAQ, ...vehiclePagefaq];
      break;
    case "pune":
      faqArray = [...PuneFAQ, ...vehiclePagefaq];
      break;
    case "chennai":
      faqArray = [...ChennaiFAQ, ...vehiclePagefaq];
      break;
    case "delhi":
      faqArray = [...DelhiAndNCRFAQ, ...vehiclePagefaq];
      break;
    default:
      break;
  }

  return (
    <CustomFaq>
      <Box className="faq-main" ref={faqRef} id="faq">
        <FAQSDK
          faqList={faqArray}
          showItems={showCount}
          headText={headText}
        />
        {/* <Box style={{ display: "flex", justifyContent: "space-between" }}>
          {showMore ? (
            <MemoizedButton
              content={"Show More"}
              sx={{
                marginTop: "20px",
                width: "100%",
                color: primary.secondary,
                background: "rgba(238, 241, 247, 0.4)",
                display: "flex",
                justifyContent: "flex-start",
                borderRadius: "0px",
                boxShadow: "none",
                border: "1px solid #eef1f766",
                borderTop: "1px solid grey",
                paddingLeft: "0px",
                "&:hover": {
                  border: "1px solid #eef1f766",
                  borderTop: "1px solid grey",
                  color: primary.secondary,
                  background: "rgba(238, 241, 247, 0.4)",
                },
                "&:disabled": {
                  border: "1px solid #eef1f766",
                  borderTop: "1px solid grey",
                  background: "rgba(238, 241, 247, 0.4)",
                },
              }}
              handleClick={() => {
                setShowLess(true);
                sendAnalytics("faq_show_more_btn_clicked", {}, "en");
                window.scrollBy({
                  top: 325,
                  left: 0,
                  behavior: "smooth",
                });
                showCount === faqArray.length - 1 && setShowMore(false);

                setShowCount(
                  faqArray.length - showCount >= 5
                    ? showCount + 5
                    : faqArray.length
                );
              }}
            />
          ) : (
            <></>
          )}

          {showLess ? (
            <MemoizedButton
              content={"Show Less"}
              sx={{
                marginTop: "20px",
                width: "100%",
                color: primary.secondary,
                background: "rgba(238, 241, 247, 0.4)",
                display: "flex",
                justifyContent: "flex-end",
                borderRadius: "0px",
                boxShadow: "none",
                border: "1px solid #eef1f766",
                borderTop: "1px solid grey",
                paddingRight: "0px",
                "&:hover": {
                  border: "1px solid #eef1f766",
                  borderTop: "1px solid grey",
                  color: primary.secondary,
                  background: "rgba(238, 241, 247, 0.4)",
                },
                "&:disabled": {
                  border: "1px solid #eef1f766",
                  borderTop: "1px solid grey",
                  background: "rgba(238, 241, 247, 0.4)",
                },
              }}
              handleClick={() => {
                setShowMore(true);
                setShowLess(false);
                sendAnalytics("faq_show_less_btn_clicked", {}, "en");
                myScroll(
                  0,
                  document.getElementById("faq")?.offsetTop - 100,
                  "smooth"
                );
                setShowCount(1);
              }}
            />
          ) : (
            <></>
          )}
        </Box> */}
      </Box>
    </CustomFaq>
  );
};

export const MemoizedFAQ = React.memo(FAQ);
